module.exports = __webpack_public_path__ + "static/media/message-icon.be5853ab.svg";